import { createAction } from '@ngrx/store';

export const openGlobalSidebar = createAction('[Global Sidebar] Open global sidebar');

export const closeGlobalSidebar = createAction('[Global Sidebar] Close global sidebar');
